import { Link } from "react-router-dom";
import { MonoLabel, btnPrimary } from "@/components/primitives";
import { useSEO } from "@/lib/useSEO";
import { PageShell } from "@/components/PageShell";

export default function NotFound() {
  useSEO({ title: "Signal Lost — Consequence Protocol", path: "/404" });
  return (
    <PageShell testId="page-404">
      <section className="container-t flex min-h-[70vh] flex-col items-center justify-center py-24 text-center">
        <MonoLabel className="text-error">ERROR 404 · SIGNAL LOST</MonoLabel>
        <h1 className="mt-6 font-display text-4xl font-bold uppercase tracking-tight text-ink sm:text-5xl">
          This route was never <span className="text-cyan">verified</span>
        </h1>
        <p className="mt-5 max-w-md text-sm leading-relaxed text-dim">
          The page you requested does not exist in the outcome registry.
        </p>
        <Link to="/" data-testid="notfound-home-link" className={btnPrimary + " mt-10"}>
          Return to protocol
        </Link>
      </section>
    </PageShell>
  );
}
